import React from "react";

import { ItemContent, Virtuoso } from "react-virtuoso";

import type { CodeAreaProps, CodeVirtualizedAreaProps } from "./Code.types";
import * as S from "./Code.styles";

/**
 * Area component for grouping code blocks
 */
export const Area = (props: CodeAreaProps) => <S.Area>{props.children}</S.Area>;

/**
 * Virtualized Area component for efficiently rendering large numbers of code blocks
 */
export const VirtualizedArea = (props: CodeVirtualizedAreaProps) => (
  <S.Area>
    <Virtuoso
      style={{ height: props.height ?? 400 }}
      totalCount={props.totalCount}
      itemContent={props.children}
    />
  </S.Area>
);
